import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, ShieldCheck, Headset } from "lucide-react";

const HERO_BG =
    "https://static.prod-images.emergentagent.com/jobs/081d5dbb-1bce-42e7-9275-26dea39b0112/images/6ad3e7671c3f2749a1a1da87ebf686ac7642ac5a6eed8838950d31c22bff3e66.png";

export default function Hero() {
    return (
        <section
            id="top"
            className="relative min-h-[100vh] flex items-center pt-40 overflow-hidden"
            data-testid="hero-section"
        >
            <div
                className="absolute inset-0 bg-cover bg-center"
                style={{ backgroundImage: `url(${HERO_BG})` }}
            />
            <div className="absolute inset-0 bg-[#0A1547]/75" />
            <div className="absolute inset-0 bg-grain opacity-60 mix-blend-overlay pointer-events-none" />
            <div
                className="absolute inset-0 pointer-events-none"
                style={{
                    background:
                        "radial-gradient(ellipse at 70% 30%, rgba(200,160,100,0.18) 0%, transparent 55%), linear-gradient(180deg, transparent 40%, #0A1547 100%)",
                }}
            />

            <div className="container-x relative z-10 grid grid-cols-1 gap-12 items-center py-20">
                <div className="max-w-5xl rise-in">
                    <div className="flex items-center gap-3 mb-8">
                        <span className="h-px w-12 bg-[#C8A064]" />
                        <span className="overline">In Partnership with Vantage Markets</span>
                    </div>

                    <h1 className="font-serif-display text-4xl sm:text-5xl lg:text-7xl leading-[1.05] text-[#F3F4F6] max-w-4xl">
                        Bridging Ambitious Traders to a{" "}
                        <em className="text-[#C8A064] not-italic">World-Class Brokerage.</em>
                    </h1>

                    <p className="mt-8 text-[#94A3B8] text-base sm:text-lg max-w-2xl leading-relaxed">
                        NexaReach LLC is the dedicated outreach partner introducing clients
                        worldwide to the regulated, institutional-grade trading environment of{" "}
                        <span className="text-[#F3F4F6]">Vantage Markets</span>. Real conversations.
                        Real expertise. Real results.
                    </p>

                    <div className="mt-10 flex flex-wrap items-center gap-4">
                        <Link to="/contact" className="btn-brass" data-testid="hero-book-call-btn">
                            Book a Discovery Call <ArrowRight size={16} />
                        </Link>
                        <Link
                            to="/vantage-markets"
                            className="btn-outline-brass"
                            data-testid="hero-explore-benefits-btn"
                        >
                            Explore Vantage Benefits
                        </Link>
                    </div>

                    <div className="mt-14 grid grid-cols-2 sm:grid-cols-3 gap-6 max-w-2xl">
                        <Trust icon={<ShieldCheck size={18} />} label="ASIC & FCA Regulated Partner" />
                        <Trust icon={<Headset size={18} />} label="Dedicated Outreach Team" />
                        <Trust label="Global Reach" />
                    </div>
                </div>
            </div>

            <div className="absolute bottom-8 left-1/2 -translate-x-1/2 hidden md:flex flex-col items-center gap-2 pulse-brass">
                <span className="text-[10px] tracking-[0.3em] text-[#C8A064] uppercase">Scroll</span>
                <span className="w-px h-10 bg-[#C8A064]" />
            </div>
        </section>
    );
}

const Trust = ({ icon, label }) => (
    <div className="flex items-center gap-2 text-[#94A3B8] text-xs sm:text-sm">
        {icon && <span className="text-[#C8A064]">{icon}</span>}
        {label}
    </div>
);
